import { useEffect, useRef } from "react";

const PARTICLE_COUNT = 300;
const COLORS = ["#00f5ff", "#bf00ff", "#00ff88"];

function rand(min, max) {
  return Math.random() * (max - min) + min;
}

export default function ParticleBackground() {
  const canvasRef = useRef(null);
  const particles = useRef([]);
  const animRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    // Initialize particles
    particles.current = Array.from({ length: PARTICLE_COUNT }, () => ({
      x:      rand(0, canvas.width),
      y:      rand(0, canvas.height),
      vx:     rand(-0.2, 0.2),
      vy:     rand(-0.4, -0.1),
      size:   rand(1, 2.5),
      color:  COLORS[Math.floor(Math.random() * COLORS.length)],
      alpha:  rand(0.1, 0.6),
      life:   rand(0, 1),
    }));

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.current.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.life += 0.003;

        if (p.y < 0 || p.life > 1) {
          p.x    = rand(0, canvas.width);
          p.y    = canvas.height + 10;
          p.life = 0;
          p.alpha = rand(0.1, 0.6);
        }

        const opacity = p.alpha * Math.sin(p.life * Math.PI);
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = p.color + Math.round(opacity * 255).toString(16).padStart(2, "0");
        ctx.fill();
      });

      animRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("resize", resize);
      if (animRef.current) cancelAnimationFrame(animRef.current);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="particle-canvas"
      aria-hidden="true"
    />
  );
}
